import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var BreadcrumbsItemComponentName = 'QuantumBreadcrumbsItem';
export function getBreadcrumbsItemUtilityClass(slot) {
    return generateUtilityClass(BreadcrumbsItemComponentName, slot);
}
export var breadcrumbsItemClasses = generateUtilityClasses(BreadcrumbsItemComponentName, [
    'root',
    'current',
    'icon',
    'label',
    'startIcon',
    'endIcon',
]);
